import { RMasseVolumiqueViscosite_Type } from '@batical/types/src'
import { fetchGeneric } from './GenericQ'
const MasseVolumiqueViscosite = require('../json/MasseVolumiqueViscosite.json')

export function fetchMasseVolumiqueViscositeSorted(): Array<{
  value: string
  label: string
}> {
  return MasseVolumiqueViscosite.sort(
    (a: RMasseVolumiqueViscosite_Type, b: RMasseVolumiqueViscosite_Type) => a.temperature - b.temperature
  ).map((child: RMasseVolumiqueViscosite_Type) => {
    return { value: child.uuid, label: child.name }
  })
}

export function fetchMasseVolumiqueViscosite(uuid: string): RMasseVolumiqueViscosite_Type {
  return fetchGeneric(MasseVolumiqueViscosite, uuid)
}
